export default "__VITE_ASSET__BzTDNm5Q__"